import { Avatar } from "@mui/material";
import { stringAvatar } from "src/helpers/helperFunctions";
import { useGetUserDetails } from "src/helpers/UserDetails";

const UserMessageAvatar = () => {
  const userDetails = useGetUserDetails();
  return (
    <Avatar
      {...stringAvatar(userDetails?.user_display_name)}
      style={{ width: "30px", height: "30px" }}
    ></Avatar>
  );
};

export default UserMessageAvatar;
